import React from "react";
import { useSelector } from "react-redux";
import classes from './NumericScore.module.css';
import SwitchToggle from "../../../../UI/SwitchToggle";


const NumericScore = ({ feedback, changeCriteriaScoreForNumeric, changeFeedbackCriterionDisable , weight , totalScore }) => {

    const { texts, direction, lang } = useSelector(state => state.translate);
 

    return (
        <div className={`${classes[direction]} ${classes.NumericScore}`}>

            <div className={classes.Header}>
                <div className={classes.NameHeader}>{texts.criteria}</div>
                <div className={classes.WeightHeader}>{texts.weight}</div>
                <div>{texts.mark}</div>
            </div>
            {feedback?.feedbackCriteria?.map((c, index) =>
                <div key={c.criteria[lang]} className={`${classes.NumericScoreRow}`} >
                    <div className={`${classes.Row} ${!c.disable ? classes.Row : classes.NoScore}`}>
                        <div className={classes.Name}>
                            <div> {c.criteria[lang]}</div>
                            {!c.optional && <div className={classes.Star}> *</div>}
                        </div>
                        <div className={classes.Weight}>{Math.round(c.weight * 100) / 100}%</div>
                        <div>
                            <input className={classes.NumberInput} type="number"
                                value={c.criteriaScoreForNumeric ? c.criteriaScoreForNumeric : ' '}
                                onChange={(e) => changeCriteriaScoreForNumeric(e.target.value, index)}
                            />
                        </div>
                    </div>
                    <div className={classes.OptinalScoreToggle}>
                        {c.optional &&
                            <SwitchToggle checked={!c.disable} setChecked={() => changeFeedbackCriterionDisable(index)} id={`${index}inUse`} />}
                    </div>
                </div>
            )}

            <div className={classes.Footer}>
                <div className={classes.NameHeader}>{texts.weightedScore}</div>
                <div className={classes.WeightHeader}>{weight}%</div>
                <div>{totalScore}</div>
            </div>
        </div>
    )
}

export default NumericScore;